import { useCallback } from 'react';
import { useCookie } from 'react-use';

import isNil from 'lodash/isNil';

import { dateHelpers } from '@nocowanie/core';

import { CookieName } from '../enums';
import { SearchEngineModel } from '../models';

export const useSearchCookie = (domain: string) => {
    const [value, updateCookie] = useCookie(CookieName.SearchCriteria);
    const currentParams = typeof value === 'string' ? JSON.parse(atob(value)) : {};

    const setCookie = useCallback(
        (params: Partial<SearchEngineModel>) => {
            const adultsCount = params.guests?.adultsCount;
            const childrenCount = params.guests?.childrenCount || 0;

            const getInstantReservation = () => {
                if (!isNil(params.instantReservation)) {
                    return params.instantReservation ? '1' : '0';
                }

                return currentParams?.instantReservation;
            };

            const data = {
                miejsca_dorosli: adultsCount,
                miejsca_dzieci: childrenCount,
                miejsca: adultsCount ? adultsCount + childrenCount : undefined,
                wiek_dzieci: params.guests?.childrenAges?.join(','),
                rezerwacja_online: getInstantReservation(),
                data:
                    params.dates?.checkInDate &&
                    params.dates.checkOutDate &&
                    dateHelpers.isValidRange(params.dates.checkInDate, params.dates.checkOutDate)
                        ? {
                              od: dateHelpers.format(params.dates.checkInDate, 'yyyy-MM-dd'),
                              do: dateHelpers.format(params.dates.checkOutDate, 'yyyy-MM-dd'),
                          }
                        : undefined,
                timestamp: Date.now(),
            };

            updateCookie(btoa(JSON.stringify(data)), {
                domain,
                expires: 7,
                secure: true,
            });
        },
        [updateCookie, domain, currentParams?.instantReservation],
    );

    return {
        setCookie,
    };
};
